
import axios from "./axios";
const rebuild = {
    // 查询委托单详情
    getCommissionedBaseInfo(params){
        return axios.get(`/train-plan-map/baseInfo/getBaseInfo`,{
            params:params
        });
    },
    // 添加火车日计划
    addTrainPlan(params){
        return axios.post(`/train-plan-map/train/train-plan`,{
           ...params
        });
    },
    // 查询火车计划列表
    getTrainPlanList(params){
        return axios.get(`/train-plan-map/train/search`,{
            params:params
        });
    },
    // 装车确认基础信息
    getTrainTransportInfo(params){
        return axios.get(`/train-transport-map/info/getBaseInfo`,{
            params:params
        });
    },
    // 保存装车确认
    saveTrainTransportLoading(params){
        return axios.post(`/train-transport-map/transport/confirmed-loading`,{
            ...params
        });
    },
    // 查询离场过账
    getDeparturePosting(params){
        return axios.get(`/train-transport-map/transport/list`,{
            params:params
        });
    },
    // 火车运输离场获取基础信息
    getLeaveBaseInfo(params){
        return axios.get(`/train-transport-map/info/getLeaveBaseInfo`,{
            params:params
        });
    },
    // 保存离场过账
    saveDeparturePosting(params){
        return axios.post(`/train-transport-map/transport/leave-place`,{
            ...params
        });
    },
    //  火车运输离场确认退回
    sendbackLeaveBaseInfo(params){
        return axios.get(`/train-transport-map/transport/send-back`,{
            params:params
        });
    },
    //火车到达确认列表
    getConfiemedArriveList(params){
        return axios.get(`/train-transport-map/transport/confiemed-arrive-list`,{
            params:params
        });
    },
    //火车到达确认
    confiemedArrive(params){
        return axios.post(`/train-transport-map/transport/confiemed-arrive`,{
            ...params
        });
    },
    //火车日计划关单
    closeTrainDailyPlan(params){
        return axios.post(`/train-plan-map/train/delete?trainPlanPk=${params.trainPlanPk}`);
    },
    //铁路品名
    getCargoCategoty(params){
        return axios.get(`/railway/cargo-categoty`,{
            params:params
        });
    },
    // 火车运输重新装车确认
    getAgainConfirmedLoadingInfo(params){
        return axios.get(`/train-transport-map/transport/again-confirmed-loading`,{
            params:params
        });
    },
    // 根据委托单查关联日计划
    getTrainDailyPlanList(params){
        return axios.get(`/train-plan-map/quote/getTrainPlan`,{
            params:params
        });
    },
    // 关闭委托单
    closeQuote(params){
        return axios.get(`/train-plan-map/quote/delete`,{
            params:params
        });
    },
    //
    getRailwaytrainType(params){
        return axios.get(`/railway/train-type`,{
            params:params
        });
    },
    //  发布承运商
    receiveConsignmentNote(params){
        return axios.post(`/DigitalFactory/receiveConsignmentNote`,{
            ...params
        });
    },
    // 火车运输重新装车运输列表
    againconfirmedList(params){
        return axios.get(`/train-transport-map/transport/again-confirmed-list`,{
            params:params
        });
    },
    // 查询物料
    getMaterialList(params){
        return axios.get(`/net-work-freight-map/material/list`,{
            params:params
        });
    },
    // 获取产品、品牌和工厂列表
    getMaterialFieldsList(params){
        return axios.get(`/net-work-freight-map/material/fields-list`,{
            params:params
        });
    },
    // 获取铁路品名列表
    getCargoCategoryList(params){
        return axios.get(`/railway/cargo-category-list`,{
            params:params
        });
    },
    // 获取离场过账票据
    getTransportLoadTicket(params){
        return axios.post(`/train-transport-map/transport/load-ticket`,params);
    },
    // 火车报表查询
    getTrainStatement(params){
        const page = params.currentPage
        delete  params.currentPage
        return axios.post(`/net-work-freight-map/carrier/railway-statement?current=${page}&size=10`,params);
    },
    // 承运商导入火车离场信息
    importLeavePlace(params){
        return axios.post(`/import-map/transport/import-leave-place`,params);
    },
    //  保存数字工厂导入信息
    dititalFacotryCarImport(params){
        return axios.post(`/import-map/save/df-import-car`,params);
    },
    // sap运单导入
   sapCarImport(params){
        return axios.post(`/import-map/save/sap-import-car`,params);
    },
    // 货主导入火车离场信息
    consignorImportLeavePlace(params){
        return axios.post(`/import-map/info/import-leave-place`,params);
    },
    // 货主导入汽车信息
    consignorImportCarLeaveTransport(params){
        return axios.post(`/import-map/info/import-car-transport`,params);
    },
    // 火车过账信息导入-磷化数字工厂专属
    railwayImportInfo(params){
        return axios.get(`/net-work-freight-map/search/railway-import-info`,{
            params:params
        });
    },
    // 数字工厂物流单导入
    digitalFactoryCarQuoteImportInfo(params){
        return axios.get(`/net-work-freight-map/search/df-car-quote-import-info`,{
            params:params
        });
    },
    // SAP运单导入
    sapCarQuoteImportInfo(params){
        return axios.get(`/sap-transport-map/search/sap-consignment-info`,{
            params:params
        });
    },
    //查询sap运单详情
    sapTransportOrder(params){
        return axios.get(`/sap-transport-map/search/sap-transport-order`,{
            params:params
        });
    },
    // 删除导入信息  /
    deleteImportInfo(params){
        return axios.get(`/net-work-freight-map/delete/quote-import-info`,{
            params:params
        });
    },

    // 查询导入对象物流委托单-火车
    getImportConsignmentInfo(params){
        return axios.get(`/net-work-freight-map/search/consignment-info`,{
            params:params
        });
    },

    //  查询汽车导入对象物流委托单
    getCarImportInfo(params){
        return axios.get(`/net-work-freight-map/search/car-quote-import-info`,{
            params:params
        });
    },
    // 执行导入汽车
    importCarTransport(params){
        return axios.post(`/import-map/transport/import-car-transport`,params);
    },
    // 执行导入司机
    importDriverInfo(params){
        return axios.post(`/import-map/info/import-driver-car`,params);
    },
    // 货主快捷导入表格数据
    getFastImportTableData(params){
        return axios.get(`/net-work-freight-map/search/quote-import-info`,{
            params:params
        });
    },
    // 保存货主导入表格信息
    saveQuoteImportInfo(params){
        return axios.post(`/import-map/save/quote-import-info`,params);
    },
    // 保存危化品信息
    saveDangerCarInfo(params){
        return axios.post(`/danger-car-transport-map/add/danger-car-info`,params);
    },
    // 保存普货车辆信息
    saveOrdinaryCarInfo(params){
        return axios.post(`/danger-car-transport-map/add/ordinary-info`,params);
    },
    // 查询危化品信息
    getDangerCarInfo(params){
        return axios.post(`/danger-car-transport-map/search/danger-car-info`,params);
    },
    // 查询普货车辆
    getOrdinaryCarInfo(params){
        // return axios.post(`/danger-car-transport-map/search/danger-car-info`,params);
        return axios.post(`/danger-car-transport-map/search/ordinary-car-info`,params);
    },
    // 查询危化品驾驶员/押运员信息
    getHazardousChemicalsInfo(params){
        //
        return axios.post(`/danger-car-transport-map/search/danger-driver-supercargo`,params);
    },
    //
    saveSapTransportOrder(data){
        return axios.post(`/sap-transport-map/update/sap-transport-order`,data);
    },
    //
    closeSapTransportOrder(data){
        return axios.get(`/sap-transport-map/close/sap-transport-order`,{params:data});
    },
    // 查字典
    getDictList(dictCode) {
        return axios.get(`/dictionary/select/${dictCode}`,{});
    }
}
export default  rebuild